import React from 'lib/react';
import {
  EVGrid, EVPaper, makeStyles, EVButton,
} from '@eagleview/ev-comp-library';
import { useTranslation } from 'lib/translation';
import {
  SERVICE_REQUEST_FORM_URL,
} from 'constants/AppConstants';
import { SUPPORT_ROUTE } from 'constants/RouteConstants';
import { useHistory } from 'lib/router';
import { useSelector } from 'lib/redux';

const useStyles = makeStyles((theme) => ({
  gridbox: {
    margin: '0px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  image: {
    width: '100%',
  },
  head: {
    fontStyle: 'normal',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '36px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: theme.evPalette.charcoal[800],
  },
  body: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0em',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    color: theme.evPalette.charcoal[800],
    wordWrap: 'break-word',
  },
  paper: {
    display: 'flex',
    flex: 1,
    margin: '0px',
    padding: '24px',
    gap: '45px',
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
      margin: '20px',
    },
  },
  linkText: {
    color: theme.evPalette.ocean[500],
    textDecoration: 'none',
    cursor: 'pointer',
  },
  serviceRequestFormContainer: {
    margin: '0px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
    height: '100%',
    '&>button#backToSupportBtn': {
      width: 'fit-content',
      textTransform: 'capitalize',
    },
    '& iframe': {
      width: '100%',
      height: '100%',
    },
  },
  serviceRequestFormFrame: {
    border: '0px',
  },
}));

function ServiceRequest() {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const userEmail = useSelector(({ userData }) => userData?.userProfile?.email);
  const serviceRequestQuerySeparator = SERVICE_REQUEST_FORM_URL.includes('?') ? '&' : '?';
  const iframeSrc = userEmail
    ? `${SERVICE_REQUEST_FORM_URL}${serviceRequestQuerySeparator}EmailParam=${userEmail}`
    : SERVICE_REQUEST_FORM_URL;
  return (
    <EVPaper className={classes.paper}>
      <EVGrid className={classes.serviceRequestFormContainer}>
        <EVButton
          id="backToSupportBtn"
          variant="outlined"
          color="primary"
          onClick={() => history.push(SUPPORT_ROUTE)}
        >
          {t('support_back_to_support')}
        </EVButton>
        <iframe
          src={iframeSrc}
          id="service-request"
          title="service-request"
          allow="fullscreen"
          align="center"
          width="fit-content"
          height="100%"
          className={classes.serviceRequestFormFrame}
        />
      </EVGrid>
    </EVPaper>
  );
}

export default ServiceRequest;
